import { render, staticRenderFns } from "./QuestionnaireFormatPageObjectsSelector.vue?vue&type=template&id=30650128&scoped=true&"
import script from "./QuestionnaireFormatPageObjectsSelector.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireFormatPageObjectsSelector.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireFormatPageObjectsSelector.vue?vue&type=style&index=0&id=30650128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30650128",
  null
  
)

export default component.exports